import React, { useRef, useState, useEffect } from 'react'
import { KnovaText } from '../../BasicUIComponents/KnovaText'

function LayoutTitle(props) {
  const { layoutData, themeName, layoutType, themeProperties, isSideMenu } =
    props

  return (
    <div
      className='layout-title-cont'
      style={{
        alignItems:
          layoutType === 'bottom-left'
            ? 'end'
            : layoutType === 'center-left'
            ? 'center'
            : 'start'
      }}
    >
      <KnovaText
        themeName={themeName}
        contBgColor={themeName === 'Theme-5' ? 'none' : 'transparent'}
        contPadding={isSideMenu ? '19px 22px' : '38px 45px'}
        text={layoutData[0].Value}
        textColor={themeProperties.themeStyles.titleColor}
        textFontSize={isSideMenu ? 'unset' : '100px'}
        textFontFamily={themeProperties.themeFont.displayFont}
        textFontWeight='400'
        textHeight='100%'
        textAlign={layoutType === 'center' ? 'center' : 'left'}
      />
    </div>
  )
}
export default LayoutTitle
